const amplifyTranslations = {
  ja: {
    // https://ui.docs.amplify.aws/react/connected-components/authenticator/customization#internationalization-i18n
    // https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/ja.ts
    // 変換されないため、設定追加
    'Enter your Username': 'ユーザー名を入力',
    // 文言修正のため、設定追加
    'Enter your username': 'メールアドレスを入力 ',
    'Forgot your password?': 'パスワードを忘れた場合',
    'Send code': '送信',
    'Send Code': '送信',
    'Sign In': 'ログイン',
    'Sign in': 'ログイン',
    'Signing in': 'ログイン中',
    'Back to Sign In': 'ログインに戻る',
    'Incorrect username or password.': 'メールアドレスまたはパスワードが違います',
    'Change Password': '変更する',
    'Invalid verification code provided, please try again.': '無効なコードが入力されました。もう一度お試しください。',
    'Attempt limit exceeded, please try after some time.': '試行制限を超えました。しばらくしてからお試しください。',
    'Password must have at least 8 characters': 'パスワードは8文字以上である必要があります。',
    'Your passwords must match': 'パスワードは一致する必要があります。'
  }
};

export default amplifyTranslations;
